// production

export const publicPath = "/yk_peking_fls_official_website";
export const apiPrefix = "http://parcloud.fengliansheng.com/spot";

// testing

// export const publicPath = "/yk_peking_fls_official_website/build";
// export const apiPrefix = "http://bjflscs.cvoon.com/spot";

// local

// export const publicPath = "";
// export const apiPrefix = "http://bjflscs.cvoon.com/spot";
